/**
 * Tipos de acciones para el módulo Kanban
 * Este archivo contiene todas las constantes de tipos de acciones
 * utilizadas por Redux en el módulo de Kanban.
 */

/**
 * Tipos de acciones para tableros
 */
// Obtener tableros
export const GET_BOARDS = 'GET_BOARDS';
export const GET_BOARDS_SUCCESS = 'GET_BOARDS_SUCCESS';
export const GET_BOARDS_ERROR = 'GET_BOARDS_ERROR';

// Crear tablero
export const CREATE_BOARD = 'CREATE_BOARD';
export const CREATE_BOARD_SUCCESS = 'CREATE_BOARD_SUCCESS';
export const CREATE_BOARD_ERROR = 'CREATE_BOARD_ERROR';

// Actualizar tablero
export const UPDATE_BOARD = 'UPDATE_BOARD';
export const UPDATE_BOARD_SUCCESS = 'UPDATE_BOARD_SUCCESS';
export const UPDATE_BOARD_ERROR = 'UPDATE_BOARD_ERROR';

// Eliminar tablero
export const DELETE_BOARD = 'DELETE_BOARD';
export const DELETE_BOARD_SUCCESS = 'DELETE_BOARD_SUCCESS';
export const DELETE_BOARD_ERROR = 'DELETE_BOARD_ERROR';

/**
 * Tipos de acciones para columnas
 */
// Obtener columnas
export const GET_COLUMNS = 'GET_COLUMNS';
export const GET_COLUMNS_REQUEST = 'GET_COLUMNS_REQUEST';
export const GET_COLUMNS_SUCCESS = 'GET_COLUMNS_SUCCESS';
export const GET_COLUMNS_ERROR = 'GET_COLUMNS_ERROR';

// Crear columna
export const CREATE_COLUMN = 'CREATE_COLUMN';
export const CREATE_COLUMN_REQUEST = 'CREATE_COLUMN_REQUEST';
export const CREATE_COLUMN_SUCCESS = 'CREATE_COLUMN_SUCCESS';
export const CREATE_COLUMN_ERROR = 'CREATE_COLUMN_ERROR';

// Actualizar columna
export const UPDATE_COLUMN = 'UPDATE_COLUMN';
export const UPDATE_COLUMN_REQUEST = 'UPDATE_COLUMN_REQUEST';
export const UPDATE_COLUMN_SUCCESS = 'UPDATE_COLUMN_SUCCESS';
export const UPDATE_COLUMN_ERROR = 'UPDATE_COLUMN_ERROR';

// Reordenar columnas
export const REORDER_COLUMNS = 'REORDER_COLUMNS';
export const REORDER_COLUMNS_SUCCESS = 'REORDER_COLUMNS_SUCCESS';
export const REORDER_COLUMNS_ERROR = 'REORDER_COLUMNS_ERROR';

// Eliminar columna
export const DELETE_COLUMN = 'DELETE_COLUMN';
export const DELETE_COLUMN_REQUEST = 'DELETE_COLUMN_REQUEST';
export const DELETE_COLUMN_SUCCESS = 'DELETE_COLUMN_SUCCESS';
export const DELETE_COLUMN_ERROR = 'DELETE_COLUMN_ERROR';

/**
 * Tipos de acciones para tableros fijados
 */
export const TOGGLE_PINNED_BOARD = 'TOGGLE_PINNED_BOARD';
export const GET_PINNED_BOARDS = 'GET_PINNED_BOARDS';
export const GET_PINNED_BOARDS_SUCCESS = 'GET_PINNED_BOARDS_SUCCESS';
export const GET_PINNED_BOARDS_ERROR = 'GET_PINNED_BOARDS_ERROR';

/**
 * Tipos de acciones para tickets
 */
// Crear ticket
export const CREATE_TICKET_REQUEST = 'CREATE_TICKET_REQUEST';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';

// Obtener tickets
export const GET_TICKETS_REQUEST = 'GET_TICKETS_REQUEST';
export const GET_TICKETS_SUCCESS = 'GET_TICKETS_SUCCESS';
export const GET_TICKETS_FAILURE = 'GET_TICKETS_FAILURE';

// Agregar tickets (para paginación)
export const APPEND_TICKETS_SUCCESS = 'APPEND_TICKETS_SUCCESS';

// Cargar tickets de forma progresiva
// LOAD_MORE_TICKETS constants eliminadas - funcionalidad simplificada

// UPDATE_TICKET_STATUS constants eliminadas - función innecesaria

// Actualizar ticket (para arrastrar y soltar)
export const UPDATE_TICKET_REQUEST = 'UPDATE_TICKET_REQUEST';
export const UPDATE_TICKET_SUCCESS = 'UPDATE_TICKET_SUCCESS';
export const UPDATE_TICKET_FAILURE = 'UPDATE_TICKET_FAILURE';

// Actualizar mapa de tickets por columna
// UPDATE_COLUMN_TICKETS_MAP eliminado - nunca se dispara

// Eliminar ticket
export const DELETE_TICKET_REQUEST = 'DELETE_TICKET_REQUEST';
export const DELETE_TICKET_SUCCESS = 'DELETE_TICKET_SUCCESS';
export const DELETE_TICKET_FAILURE = 'DELETE_TICKET_FAILURE';

// Filtros de fecha para tickets
export const SET_DATE_FILTERS = 'SET_DATE_FILTERS';
export const CLEAR_DATE_FILTERS = 'CLEAR_DATE_FILTERS';

// Estados simples para cargar más tickets (sin cambios backend)
export const SET_COLUMN_LOADING_MORE = 'SET_COLUMN_LOADING_MORE';

// Paginación por páginas tradicional
export const SET_COLUMN_PAGE = 'SET_COLUMN_PAGE';
export const UPDATE_COLUMN_PAGINATION = 'UPDATE_COLUMN_PAGINATION';
export const LOAD_PAGE_TICKETS_SUCCESS = 'LOAD_PAGE_TICKETS_SUCCESS';

// Actualizar items globales de tickets
// UPDATE_TICKETS_ITEMS eliminado - nunca se dispara

/**
 * Tipos de acciones para actualizaciones granulares
 */
// UPDATE_COLUMN_TICKETS eliminado - nunca se dispara
// UPDATE_COLUMN_METADATA y ADD_NEW_COLUMN eliminados - nunca se disparan
// ADD_NEW_TICKET y UPDATE_TICKET_POSITION eliminados - nunca se dispatchen

// Nuevo tipo para marcar tickets verificados después de manejo optimista
// MARK_TICKET_VERIFIED eliminado - se usa string literal directo

/**
 * Tipos de acciones para navegación limpia
 */
// Seleccionar tablero activo (para navegación limpia sin parámetros en URL)
export const SET_SELECTED_BOARD_ID = 'SET_SELECTED_BOARD_ID';
export const CLEAR_SELECTED_BOARD_ID = 'CLEAR_SELECTED_BOARD_ID';